
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videos/[...alias]",
      function () {
        return require("private-next-pages/videos/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/videos/[...alias]"])
      });
    }
  